import React from "react";
import { LEGAL_DOCS } from "./legalTexts";

// Standalone-Version (ohne react-router): erwartet docKey ("impressum" | "agb" | "datenschutz") und onBack.
export const LegalPage = ({ docKey, onBack }) => {
  const doc = LEGAL_DOCS[docKey];
  if (!doc) return null;
  return (
    <div className="min-h-screen bg-[var(--brand-bg)]" data-testid={`legal-page-${docKey}`}>
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="flex items-center justify-between mb-6">
          <h1 className="font-[Playfair_Display] text-2xl font-bold text-[var(--brand-ink)]">{doc.label}</h1>
          <button
            onClick={onBack}
            className="text-sm px-4 py-2 rounded-full border border-[var(--brand-border)] hover:bg-white"
            data-testid="legal-page-back"
          >
            ← Zur Startseite
          </button>
        </div>
        <div className="bg-white rounded-lg border border-[var(--brand-border)] p-2">
          <iframe
            title={doc.label}
            src={doc.url}
            className="w-full rounded-md bg-white"
            style={{ minHeight: "80vh" }}
            data-testid={`legal-page-iframe-${docKey}`}
          />
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
